import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HeroSection from "../components/HeroSection";

const links = [
  {
    name: "About",
    path: "/portfolio",
  },
  {
    name: "Projects",
    path: "/portfolio/projects",
  },
  {
    name: "Skills",
    path: "/portfolio/skills",
  },
  {
    name: "Experience",
    path: "/portfolio/experience",
  },
  {
    name: "Testimonials",
    path: "/portfolio/testimonials",
  },
];

const LandingPage: React.FC = () => {
  const location = useLocation();

  const handleOpenSidebar = () => {
    const sidebar = document.getElementById("sidebar");
    const closeIcon = document.getElementById("sidebar-close");

    sidebar?.classList.remove("translate-x-[100%]");
    sidebar?.classList.add("translate-x-0");

    closeIcon?.classList.remove("flex");
    closeIcon?.classList.add("hidden");
  };

  const handleCloseSidebar = () => {
    const sidebar = document.getElementById("sidebar");
    const closeIcon = document.getElementById("sidebar-close");

    sidebar?.classList.remove("translate-x-0");
    sidebar?.classList.add("translate-x-[100%]");
    closeIcon?.classList.remove("hidden");
    closeIcon?.classList.add("flex");
  };

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col justify-between">
      <header className="bg-white shadow sticky top-0 z-50">
        <nav className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <Link to={"/"} className="font-bold text-xl">
                Madaminjon
              </Link>
            </div>

            <div className="flex items-center gap-5">
              <Link
                to="portfolio/contact"
                className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg"
              >
                Contact
              </Link>
              {location.pathname.includes("portfolio") ? (
                <IconButton
                  id="sidebar-open"
                  className="flex"
                  onClick={handleOpenSidebar}
                >
                  <MenuIcon />
                </IconButton>
              ) : (
                <Link
                  to="/portfolio"
                  className="text-gray-600 hover:text-gray-800 font-medium mx-3 sm:mx-4"
                >
                  Portfolio
                </Link>
              )}
            </div>

            <aside
              id="sidebar"
              className="flex flex-col fixed h-full right-0 top-0 w-[200px] sm:w-[300px] items-center py-8 bg-white gap-3 transition-transform duration-300 translate-x-[100%]"
            >
              <IconButton onClick={handleCloseSidebar}>
                <CloseIcon />
              </IconButton>
              <hr className=" border-black  w-full" />
              {links.map((link) => (
                <Link
                  onClick={handleCloseSidebar}
                  key={link.name}
                  to={link.path}
                  className={
                    "text-gray-600 hover:text-gray-800 hover:bg-gray-100 w-full p-2 text-center font-medium mx-3 sm:mx-4"
                  }
                >
                  {link.name}
                </Link>
              ))}
            </aside>
          </div>
        </nav>
        <span className="absolute bottom-[-32px] flex w-full pl-10 sm:pl-20 justify-start z-0">
          <Link
            to={"/blogs"}
            className="text-white h-8 px-5 bg-red-400 hover:bg-red-500 hover:underline shadow-md flex justify-center items-center rounded-b-md font-semibold animate-bounce transition-all duration-300 ease-in-out"
          >
            Blogs
          </Link>
        </span>
      </header>

      {location.pathname === "/" && <HeroSection />}

      <div onClick={handleCloseSidebar}>
        <Outlet />
      </div>

      {location.pathname !== "/" && (
        <footer className="bg-gray-200 py-4">
          <div className="container mx-auto text-center text-gray-600 z-40">
            &copy; {new Date().getFullYear()} Madaminjon. All rights reserved.
          </div>
        </footer>
      )}
    </div>
  );
};

export default LandingPage;
